import React from 'react';
import SIcon from './SIcon';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';

const Icon = props => <SIcon {...props} icon={faCircleInfo} fa />;

export default Icon;
